import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const Bullet = ({
    width,
    height,
    fill,
    dispatch, // eslint-disable-line
    ...props
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 10"
        fill={fill}
        {...props}
    >
        <polygon points="0 0 6 10 12 0 " />
    </svg>
);

Bullet.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.string,
};

Bullet.defaultProps = {
    width: 10,
    height: 12,
    fill: PropTypes.string,
};

export default connect(({ theme }) => ({
    fill: theme.primaryColor,
}))(Bullet);



// WEBPACK FOOTER //
// ./src/client/Components/Icons/SelectArrow.js